import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, Container } from '@mui/material';
import { SeasonProvider } from '../../../context/SeasonContext';
import AdminSeasonLayout from '../../../components/admin/AdminSeasonLayout';
import { fetchSeason, fetchSubleaguesForSeason } from '../../../services/seasons';
import { page } from '../../../theme/commonStyles';

/**
 * Laadt het seizoen uit de route en zet het in de SeasonContext, zodat alle
 * onderliggende adminpagina's het seizoen niet meer zelf hoeven te kiezen.
 * Spiegelt AuctionEnvironment voor het veilinggedeelte.
 */
function AdminSeasonEnvironment() {
    const { seasonId } = useParams();
    const [season, setSeason] = useState(null);
    const [subleagues, setSubleagues] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        let cancelled = false;

        const load = async () => {
            setLoading(true);
            setError('');
            try {
                const [seasonDoc, seasonSubleagues] = await Promise.all([
                    fetchSeason(seasonId),
                    fetchSubleaguesForSeason(seasonId),
                ]);
                if (cancelled) return;

                if (!seasonDoc) {
                    setError(`Seizoen ${seasonId} bestaat niet.`);
                } else {
                    setSeason(seasonDoc);
                    setSubleagues(seasonSubleagues);
                }
            } catch (err) {
                console.error('Kon seizoen niet laden:', err);
                if (!cancelled) setError('Het seizoen kon niet geladen worden.');
            } finally {
                if (!cancelled) setLoading(false);
            }
        };

        load();
        return () => { cancelled = true; };
    }, [seasonId]);

    if (loading) {
        return (
            <Box sx={page.fullscreenLoadingContainer}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Container maxWidth="sm" sx={{ pt: 8 }}>
                <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>
                <Button variant="contained" href="/admin">Terug naar seizoenen</Button>
            </Container>
        );
    }

    return (
        <SeasonProvider season={season}>
            <AdminSeasonLayout subleagueCount={subleagues.length} />
        </SeasonProvider>
    );
}

export default AdminSeasonEnvironment;
